import React from "react";
import { connect } from "redux-bundler-react";
import GTMPageViewTracker from 'components/utilities/GTMPageViewTracker';

const GTMPageViewTrackerContainer = ({ pageData: { meta, url } }) => (
  <GTMPageViewTracker url={url} meta={meta} />
);

export default connect("selectPageData", GTMPageViewTrackerContainer);
